/* eslint-disable */
import { NavigationItem } from '@base/navigation/navigation.types';

export const defaultNavigation: NavigationItem[] = [
  {
    id: 'users',
    title: 'Users',
    type: 'basic',
    icon: 'mat_outline:group',
    link: '/users',
  },
  {
    id: 'pdf-summaries',
    title: 'PDF Summaries',
    type: 'basic',
    icon: 'mat_outline:summarize',
    link: '/pdf-summaries',
  },
  {
    id: 'api-keys',
    title: 'API Keys',
    subtitle: 'Anthropic Keys',
    type: 'basic',
    icon: 'key',
    link: '/api-keys',
  },
  {
    id: 'discount-codes',
    title: 'Discount Codes',
    subtitle: 'Manage discount codes',
    type: 'basic',
    icon: 'mat_outline:percent_discount',
    link: '/discount-codes',
  },
  {
    id: 'document-types',
    title: 'Document Types',
    type: 'basic',
    icon: 'article',
    link: '/document-types',
  },
  {
    id: 'prompts',
    title: 'Prompts',
    subtitle: 'AI Prompts Management',
    type: 'basic',
    icon: 'mat_outline:smart_toy',
    link: '/prompts',
  },
  {
    id: 'disposable-email',
    title: 'Disposable Email',
    subtitle: 'Disposable Domains',
    type: 'basic',
    icon: 'block',
    link: '/disposable-email',
  },
  {
    id: 'do-spaces',
    title: 'DigitalOcean Spaces',
    type: 'basic',
    icon: 'files',
    link: '/do-spaces',
  },
];
